<template>
  <v-alert
    type="error"
    dense
    outlined
    class="mb-4"
  >
    <v-row
      align="center"
      dense
    >
      <v-col class="grow">
        {{ message }}
      </v-col>
      <v-col class="shrink">
        <v-btn
          small
          outlined
          color="error"
          :loading="loading"
          @click="$emit('retry')"
        >
          <v-icon
            left
            small
          >
            mdi-refresh
          </v-icon>
          Retry
        </v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
export default {
  name: 'SectionError',
  props: {
    message: { type: String, default: 'Failed to load data' },
    loading: { type: Boolean, default: false }
  }
};
</script>
